import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

import { chain, find, isEqual, map, isEmpty } from 'lodash';

import { rx } from '@app/shared/rx';
import { UiActions } from '@app/store/actions';
import { API_ERROR_CODES, ERROR_PAGE_TEMPLATES } from '@app/text-content';
import { Observable, of } from 'rxjs';
import { NO_PERMISSION_STATUS } from '@app/shared/constants';
import { I18n } from '@app/i18n/strings-keys';
import { XVII18nService } from '@app/i18n/services';

@Injectable()
export class HttpErrorService {
  public constructor(
    public http: HttpClient,
    public uiActions: UiActions,
    public i18nService: XVII18nService,
  ) {}

  public catchNoPermissionHttpError<T = any>(
    errors: HttpErrorResponse['error'] | HttpErrorResponse['error'][],
    options?: { isBrokenWhenNoPermission: boolean },
  ): Observable<T> {
    const { isBrokenWhenNoPermission = false } = options ?? {};

    const hasNoPermissionError = find(errors, (errorItem) =>
      isEqual(errorItem.status, NO_PERMISSION_STATUS),
    );
    if (hasNoPermissionError) {
      map(errors, (errorItem) => {
        const toast = {
          errors: {
            title: errorItem.meta.code,
            message: errorItem.meta.message,
          },
        };

        this.uiActions.showErrorToasterMessage(toast);
      });

      const permissionMessage: string = chain(errors)
        .map('meta')
        .filter({ code: API_ERROR_CODES.NO_PERMISSIONS_CODE } as object)
        .map('data.permissions')
        .flatten()
        .uniq()
        .sort()
        .join(', ')
        .replace(
          /^\b/,
          this.i18nService.translate(
            I18n.ErrorMessages.YouAreMissingTheFollowingPermissions,
            { permissions: '' },
          ),
        )
        .value();

      this.uiActions.showErrorPage({
        ...ERROR_PAGE_TEMPLATES.NOT_PERMITTED_ERROR_PAGE_TEMPLATE,
        details: permissionMessage,
      });

      return of({} as any).pipe(
        rx.filter((newResult) => {
          return isBrokenWhenNoPermission ? !isEmpty(newResult) : true;
        }),
      );
    }
  }
}
